module.exports = __webpack_public_path__ + "fransa mutfak 13.jpg?72f8957e5f59bf82c88c05fb64d1324b";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa mutfak 13.jpg
// module id = 344
// module chunks = 0